<template>
  <table id="template-builder-footer" align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" :style="`margin: auto; background-color: ${background_color};`" class="email-container footer">
    <tr v-if="organization.social_links.length > 0">
      <td style="padding: 20px 20px 0 20px; font-size: 18px; line-height: 36px; text-align: center; color: #888888;">
        <a v-for="link in organization.social_links"
          v-bind:key="link.source"
          :href="link.url"
          target="_blank"
          style="color: #333333; padding: 0 5px;"
        >
          <img :src="`https://activitymessenger-assets-ca.s3.amazonaws.com/social/${link.source}.png`" style="width: 24px; height: 24px;" />
        </a>
      </td>
    </tr>
    <tr>
      <td style="padding: 20px; font-size: 12px; line-height: 15px; text-align: center; color: #888888;">
        <div v-html="footerHtml"></div>
        <br v-if="show_actions" /><br v-if="show_actions" />
        <a v-if="show_actions" href="#" @click.prevent style="color: #333333;">
          {{ trans('manage_notifications') }}
        </a>
        <span v-if="show_actions">&#8226;</span>
        <a v-if="show_actions" href="#" @click.prevent style="color: #333333;">
          {{ trans('view_in_browser') }}
        </a>
        <div v-if="!organization.is_white_labeled">
          <br/><br/>
          <a href="https://activitymessenger.com" :title="trans('footer_logo_alt')" @click.prevent style="color: #333333;">
            <img :src="trans('footer_logo_url')" :alt="trans('footer_logo_alt')" style="vertical-align:unset;" />
          </a>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    props: {
      organization: Object,
      show_actions: {
        type: Boolean,
        default: false,
      },
      background_color: String,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
      }
    },
    computed: {
      footerHtml() {
        let placeholders = _.createPlaceholdersForOrganization(this.organization)
        return _.replacePlaceholders(this.organization.footer_html || trans('footer_html'), placeholders)
      },
    },
    mounted() {
      window.footerComponent = this
    },
  }
</script>